import dayjs from 'dayjs'

import utc from 'dayjs/plugin/utc'

import LocalizedFormat from 'dayjs/plugin/localizedFormat'

import 'dayjs/locale/pt-br'

dayjs.extend(LocalizedFormat)
dayjs.extend(utc)

function resolveTimezone() {
  try {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
    const etc = 'Etc/GMT'

    if (timezone.startsWith(etc)) {
      const timezoneNumber = parseInt(timezone.replace(etc, ''), 10)
      return timezoneNumber * -60
    }
  } catch (ex) {
    console.error(ex)
  }

  return new Date().getTimezoneOffset()
}

const timezoneMinutes = resolveTimezone()

export default (value, mask) => {
  return dayjs
    .utc(value)
    .subtract(timezoneMinutes, 'minutes')
    .locale('pt-br')
    .format(mask)
}
